import './index.css';

export default {
  name: 'AtMap',
  props: {
    id: { type: String, default: () => (`a-t-map-${Math.random().toString().substring(2)}`) },
    url: { type: String, default: () => 'http://api.tianditu.gov.cn/api?v=4.0&tk=cfa823d91d24d8448f3b7f8cd7cd45c5' },
    center: { type: Array, default: () => [116.40769, 39.89945] },
    zoom: { type: Number | String, default: () => 12 },
  },
  data() {
    return {
      scriptId: `script-${this.id}`,
      map: null,
      loading: false,
    }
  },
  created() {
    this.create();
  },
  destroyed() {
    this.cancel();
  },
  methods: {
    onload(url, callback = null) {
      let script = document.createElement('script');
      script.id = this.scriptId;
      script.src = url;
      if (callback) {
        script.onload = script.onreadystatechange = () => {
          if (!script.readyState || (script.readyState == 'loaded' || script.readyState == 'complete')) {
            callback();
            script.onreadystatechange = null;
            script.onload = null;
          }
        };
      }
      let head = document.querySelector('head');
      head && (head.appendChild(script));
    },
    create() {
      this.loading = true;
      this.onload(this.url, () => {
        if (T) {
          console.log(T);
          this.map = new T.Map(this.id);
          this.map.centerAndZoom(new T.LngLat(...this.center), parseInt(this.zoom));
          this.loading = false;
        }
      });
    },
    cancel() {
      if (this.map) {
        this.map.reset();
        this.map = null;
      }
      let lastScript = document.head.lastChild;
      if (lastScript && (lastScript.nodeName == 'SCRIPT')) lastScript.remove();
      this.$nextTick(() => {
        let headScript = document.getElementById(this.scriptId);
        if (headScript) headScript.remove();
      });
    },
  },
  render() {
    const { width = '100%', height = '100%' } = this.$attrs;
    return (<div id={this.id} class="a-t-map" v-loading={this.loading} style={{ width, height }} />);
  }
}